import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

export const saveInvoiceDescriptionUpdate = async (name: string, template: string, templateId: number): Promise<any> => {
   const token = localStorage.getItem('authToken');

   if (!token) {
      throw new Error('Authorization token not found');
   }

   const response = await axios.put(`https://${apiURL}/InvoiceTemplate/${templateId}`,{ name: name, template: template, invoiceTemplateId: templateId}, {
      headers: {
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + token,
      }
   });

 console.log(response)
};